import type { G_VideoListFreeItem, G_VideoViewingType } from "~/lib/graphql";

// 作品一覧に合わせてqueryを変換
const keyConvertor = (key: string) => {
  if (key === "viewingTypes") return "viewing_types";
  if (key === "contentType") return "content_types";
  return key;
};

// arrayの場合hoge,huga...のstringに変換
const valueConvertor = (value: string | string[] | G_VideoViewingType[] | null) => {
  if (Array.isArray(value)) {
    const joinedValues = value.join();
    return joinedValues;
  }
  return value;
};

export const convertListQuery = (filter: G_VideoListFreeItem["filter"]) => {
  // 1. nullとtypenameを削除する
  const removedNull = Object.fromEntries(
    Object.entries(filter).filter(([key, value]) => {
      return value !== null && key !== "__typename";
    })
  );

  // 2. 作品一覧のqueryに合わせてfixする処理
  const query = Object.fromEntries(
    Object.entries(removedNull).map(([key, value]) => {
      const convertedKey = keyConvertor(key);
      const convertedValue = valueConvertor(value);
      return [convertedKey, convertedValue];
    })
  );

  return { query };
};
